import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "gap_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[70] rounded-2xl bg-[#101A2E]/95 backdrop-blur-xl border border-[#D4AF37]/30 shadow-[0_20px_60px_rgba(0,0,0,0.6)] p-6"
          data-testid="cookie-banner"
        >
          <div className="flex items-start gap-4">
            <Cookie className="text-[#D4AF37] shrink-0 mt-0.5" size={22} />
            <div>
              <p className="text-sm text-[#F6F1E6] font-medium mb-1">Respect de votre vie privée</p>
              <p className="text-xs text-[#9AA3B5] leading-relaxed">
                Ce site n'utilise pas de cookies publicitaires ni de traçage. Seuls des stockages techniques
                nécessaires au fonctionnement sont utilisés. Consultez notre{" "}
                <Link to="/confidentialite" className="text-[#E5C158] underline underline-offset-2" data-testid="cookie-privacy-link">
                  politique de confidentialité
                </Link>.
              </p>
              <div className="flex gap-3 mt-4">
                <button onClick={() => choose("accepted")} data-testid="cookie-accept-btn" className="gold-button rounded-full px-5 py-2 text-xs font-medium tracking-[0.12em] uppercase">
                  Accepter
                </button>
                <button onClick={() => choose("refused")} data-testid="cookie-refuse-btn" className="outline-button rounded-full px-5 py-2 text-xs font-medium tracking-[0.12em] uppercase">
                  Refuser
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
